export default __webpack_public_path__ + "static/reading-59b84f4923c9fbf2381cc17f25dea0c4.pdf";